// IMPORTS
// Modules
import { Link } from 'react-router-dom';


// COMPONENT
export default function Expirations (props) {
   // Component
   return (
      <div className='oneport-dashboard-expirations'>
         {props.parent.expirations && props.parent.expirations.length > 0 && props.parent.expirations.map(function (expiration, i) {
            return (
               <Link key={`oneport-dashboard-expirations-expiration-${i}`} to={`/oneport/device?id=${expiration.device_id}`} className='oneport-dashboard-expirations-expiration'>
                  <p className={`oneport-dashboard-expirations-expiration-${expiration.status}`}>{expiration.name} <span>({expiration.device_name})</span></p>
                  <input type='datetime-local' className='ohsinput' defaultValue={expiration.expiration} readOnly={true} />
               </Link>
            );
         })}
      </div>
   );
}